<script setup>
import { defineProps } from "vue"
import { apiUrl, defaultImage } from "@common/helpers"

const props = defineProps({
  manufacturer: {
    required: true,
    type: Object,
  },
})
</script>

<template>
  <div class="md:flex md:items-center md:justify-between md:space-x-5">
    <div class="flex items-start space-x-5">
      <div class="shrink-0">
        <div class="relative">
          <img
            class="h-16 rounded-lg ring-1 ring-gray-900/10"
            :src="
              manufacturer.logo
                ? apiUrl(manufacturer.logo.original.url)
                : defaultImage
            "
            alt=""
          />
          <span
            class="absolute inset-0 rounded-full shadow-inner"
            aria-hidden="true"
          />
        </div>
      </div>
      <div class="pt-1.5">
        <h1 class="text-2xl font-bold text-gray-900">
          {{ manufacturer.companyName }}
        </h1>
        <p class="text-sm font-medium text-gray-500">
          {{ manufacturer.address }}
        </p>
      </div>
    </div>
  </div>
</template>
